import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64Decode',
})
export class Base64DecodePipe implements PipeTransform {

  public transform(value: any, args?: any): any {
    return atob(value);
  }

}
